/**
 * SectionHeading
 *
 * Props:
 *   label: small uppercase label above the title (e.g. "What We Offer")
 *   title: h2 text
 *   sub: subtitle paragraph
 */
function SectionHeading({ label, title, sub }) {
  return (
    <>
      {label && <p className="section-label">{label}</p>}
      {title && <h2 className="section-title">{title}</h2>}
      {sub && <p className="section-sub">{sub}</p>}
    </>
  );
}

export default SectionHeading;
